export const GOAL_MINUTES = 60;

/**
 * How far through the day's goal the time logged is, capped at 1.
 */
export function getGoalProgress(minutes: number): number {
  return Math.min(minutes / GOAL_MINUTES, 1);
}

/**
 * Minutes still to log before the day's goal is met.
 */
export function getGoalRemaining(minutes: number): number {
  return Math.max(GOAL_MINUTES - minutes, 0);
}
